const containerStyle = {
  height: "auto",
  background: "white",
  padding: 10,
  pointerEvents: "all"
};

const linkStyle = {
  display: "inline-block",
  background: "transparent",
  borderBottom: "4px solid #33c5c596",
  color: "black",
  padding: "0px",
  pointerEvents: "all"
};

const paralinkStyle = {
  display: "inline-block",
  background: "transparent",
  color: "#de1b84",
  padding: "0px",
  pointerEvents: "all"
};

const colonyStyle = {
  display: "none",
  width: 200,
  height: 150
};

const titleStyle = { margin: 0, marginBottom: 10, fontSize: 18, color: "#666" };

export const theme = {
  containerStyle,
  linkStyle,
  paralinkStyle,
  titleStyle,
  colonyStyle
};



// WEBPACK FOOTER //
// ./src/components/theme/Theme.js